import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Check, Sparkles } from 'lucide-react';

export const SiteSelector = ({ sites, selectedSite, onSelect }) => {
  return (
    <Card
      data-testid="site-selector-card"
      className="border border-[#B8860B]/30 shadow-xl bg-[#0B132B]"
    >
      <CardHeader>
        <CardTitle className="text-2xl text-[#F4F1EA]">Select Your Site</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {sites.map((site) => (
            <div
              key={site.id}
              data-testid={`site-option-${site.id}`}
              onClick={() => onSelect(site)}
              className={`relative cursor-pointer rounded-xl border-2 p-6 transition-all duration-300 hover:shadow-lg ${
                selectedSite?.id === site.id
                  ? 'border-[#B8860B] bg-[#B8860B]/10 shadow-lg'
                  : 'border-[#B8860B]/20 bg-[#050814] hover:border-[#B8860B]'
              }`}
            >
              {site.popular && (
                <Badge className="absolute -top-3 -right-3 bg-[#B8860B] text-[#050814] hover:bg-[#B8860B]">
                  <Sparkles size={14} className="mr-1" />
                  Popular
                </Badge>
              )}

              <h3 className="text-xl font-bold text-[#F4F1EA] mb-2">{site.name}</h3>
              <div className="text-3xl font-bold text-[#B8860B] mb-4">
                ${site.price.toFixed(2)}
                <span className="text-sm text-[#F4F1EA]/70 font-normal">/night</span>
              </div>

              <p className="text-sm text-[#F4F1EA]/70 mb-4 italic">{site.description}</p>

              <ul className="space-y-2">
                {site.features.map((feature, index) => (
                  <li key={index} className="flex items-start text-sm text-[#F4F1EA]/80">
                    <Check size={16} className="text-[#B8860B] mr-2 flex-shrink-0 mt-0.5" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {selectedSite?.id === site.id && (
                <div className="absolute top-4 right-4">
                  <div className="w-6 h-6 bg-[#B8860B] rounded-full flex items-center justify-center">
                    <Check size={16} className="text-[#050814]" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-[#050814] rounded-lg border-l-4 border-[#B8860B]">
          <p className="text-sm text-[#F4F1EA]/80">
            <strong className="text-[#B8860B]">Adults Only Resort:</strong> Creek Bottom Ranch & Resort is an adults-only (21+) retreat in the heart of the Pineywoods of East Texas.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
